import { Component, OnInit } from '@angular/core';

import { routes as r1 } from './accounts/accounts-routing.module';
import { ConfigurationComponent } from './configuration/configuration.component';
import { ManageCustomersComponent } from './accounts/manage-customers/manage-customers.component';
import { UserProfileService, ProductRouteInfoService, ProductData } from '../core';
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  notificationReports:Array<ProductData>;

  constructor(private userProfileService:UserProfileService,private productRouteInfoService: ProductRouteInfoService) {
    let user = this.userProfileService.data;

    this.notificationReports = [
      {id:'notUsed', text: 'Configuration', path: 'configuration', mainPath: '/admin/configuration'}
    ];

    if(user.RoleList.includes('Super User')) {
      this.notificationReports.push({id: 'notUsed', text: 'Manage Customers', path:'accounts/manage-customers', mainPath:'/admin/accounts/manage-customers'});
    } else if(user.RoleList.includes('Corporate Admin')) {
      this.notificationReports.push({id: 'notUsed', text: 'Manage Users', path:'accounts/manage-users', mainPath: '/admin/accounts/manage-users'});
    }
    else if(user.RoleList.length == 1  && user.RoleList[0] == "Registered User"){
      this.userProfileService.TakeUserToLogoutPage();
    }

    if(user.ProductAccess.length>0) {
      var reportsMapping = this.productRouteInfoService.GetReports(user.ProductAccess);
      this.notificationReports = this.notificationReports.concat(
        reportsMapping.map(r => {r.path = '/' + r.path; return r;})
      );
    }
  }

  ngOnInit() {
  }

}
